module.exports = __webpack_public_path__ + "img/index-item3.653dd4e6.png";